import { emptyEntityKey } from './../../pma-entity/pma-entity-types';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { GetOverviewResponse } from '../models/overview';
import { EntityKey } from '@feature/pma-entity/pma-entity-types'
import { IOverviewConfigurationModel } from '../models/overview-configuration-model';
import { UrlBuilderService } from '../../common/services/url-builder.service';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class OverviewHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilderService: UrlBuilderService
  ) { }

  getOverview(key: EntityKey): Observable<GetOverviewResponse> {
  
    const k = key || emptyEntityKey ;
    return this.http
      .post<GetOverviewResponse>(this.urlBuilderService.getUrl('overview/bykey'), k );
  }

  getOverviewConfiguration(productName: string = ''): Observable<IOverviewConfigurationModel> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('product', productName);

    const overviewUrl = this.urlBuilderService.getUrl('overview/configuration');
    return this.http
      .get<IOverviewConfigurationModel>(overviewUrl, { params: httpParams }).pipe(
        map(overview => overview || undefined)
      );
  }

  updateOverviewConfiguration(model: IOverviewConfigurationModel): Observable<string> {
    const configUrl = `${API_URL}overview/configuration`;
    const result = this
      .http
      .post(configUrl, model, { responseType: 'text' });

    return result;
  }

}

